import React, { useState, useRef } from 'react';
import {
  Autocomplete,
  Container,
  Paper,
  Grid,
  IconButton,
  Typography,
  Tooltip,
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import DatePicker from 'react-multi-date-picker';
import 'react-multi-date-picker/styles/layouts/mobile.css';
import { useDispatch } from 'react-redux';
import KeycloakService from '../../services/KeycloakService';
import {
  CANCEL_BUTTON_TEXT,
  ERROR_KEY,
  SHOW_NOTIFICATION,
  SUBMIT_BUTTON_TEXT,
  SKILL_SUBMISSION_ERROR,
} from '../../constants';
import {
  addEmployeeSkill,
  editEmployeeSkill,
} from '../../tech-council/Services/SkillsService';
import { getSkills } from '../../admin/Services/MasterdataService';

const AddSkill = (props) => {
  const { handleClose, editing, editSkill } = props;
  const currentUserId = KeycloakService.getUserDetail();
  const [skills, setSkills] = useState([]);
  const [loadingApiCall, setLoadingApiCall] = useState(false);
  const [search, setSearch] = useState(new Map());
  const [value, setValue] = useState(new Map());
  const datePickerRef = useRef();
  const [toSubjects, setToSubjects] = useState([]);
  const dispatch = useDispatch();
  const [noSkillsAdded, SetNoSkillsAdded] = useState(false);

  React.useEffect(() => {
    loadData();
    if (editing) {
      const newSkill = {
        employeeId: parseInt(currentUserId),
        skillName: editSkill?.skillName,
        datesArray: editSkill?.datesArray,
        selfRating: editSkill?.approvedRating,
        skillId: editSkill?.skillId,
        id: editSkill?.skillEmployeeMappingId,
        skillError: false,
        ratingError: false,
        rangeError: false,
      };
      setSkills([newSkill]);
    } else {
      const newSkill = {
        employeeId: currentUserId,
        skillName: '',
        datesArray: [],
        selfRating: '',
        skillId: -1,
        skillError: false,
        ratingError: false,
        rangeError: false,
      };
      setSkills([newSkill]);
    }
  }, []);

  const loadData = async () => {
    const subjects = await getSkills();
    if (subjects.status !== 200) {
      dipatchNotification(subjects.type, subjects.message);
    }
    if (subjects.isError === false) {
      setToSubjects(() => subjects.data.data);
    }
  };

  const addSkill = () => {
    if (noSkillsAdded) SetNoSkillsAdded(false);
    const newSkill = {
      employeeId: currentUserId,
      skillName: '',
      datesArray: [],
      selfRating: '',
      skillId: -1,
      skillError: false,
      ratingError: false,
      rangeError: false,
    };
    setSkills([...skills, newSkill]);
  };

  const checkOptions = (str, index) => {
    const updatedSearch = new Map(search);
    updatedSearch.set(index, str !== '');
    setSearch(updatedSearch);
  };

  const handleDurationChange = (valu, index) => {
    const updatedSkills = [...skills];
    const durations = valu.map((bothMonth) => {
      const bothMonthString = String(bothMonth);
      const [startMonth, endMonth] = bothMonthString.split(',');
      return { startMonth, endMonth };
    });
    updatedSkills[index].datesArray = durations;
    updatedSkills[index].rangeError = false;
    setSkills(updatedSkills);

    const val = new Map(value);
    val.set(index, valu);
    setValue(val);
  };

  const handleResetDuration = (index) => {
    const updatedSkills = [...skills];
    updatedSkills[index].datesArray = [];
    setSkills(updatedSkills);

    const val = new Map(value);
    val.set(index, null);
    setValue(val);
    datePickerRef?.current?.children[1]?.children[0]?.children[0]?.children[1]?.children[1].click();
  };

  const handleSkillNameChange = (val, index) => {
    const updatedSkills = [...skills];
    updatedSkills[index].skillName = val.skillName;
    updatedSkills[index].skillId = val.skillId;
    updatedSkills[index].skillError = false;
    setSkills(updatedSkills);
    const updatedSearch = new Map(search);
    updatedSearch.set(index, false);
    setSearch(updatedSearch);
  };

  const handleRemoveSkill = (index) => {
    const updatedSkills = [...skills];
    updatedSkills.splice(index, 1);
    setSkills(updatedSkills);
  };

  const handleRatingChange = (event, index) => {
    const updatedSkills = [...skills];
    updatedSkills[index].selfRating = event.target.value;
    updatedSkills[index].ratingError = false;
    setSkills(updatedSkills);
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const dataValidation = () => {
    console.log(skills, 'skills');
    const updatedSkills = skills.map((payload) => {
      const updatedSkill = payload.skillName.length !== 0;
      const updatedRating = payload.selfRating.length !== 0;
      const updatedDatesArray = payload.datesArray.length !== 0;
      return {
        ...payload,
        skillError: !updatedSkill,
        ratingError: !updatedRating,
        rangeError: !updatedDatesArray,
      };
    });

    setSkills(updatedSkills);
    const hasError = updatedSkills.some((payload) => {
      return payload.skillError || payload.ratingError || payload.rangeError;
    });
    if (hasError) return false;
    return true;
  };

  const CreatePayloadforApiCall = () => {
    let payload = [];
    skills.forEach((obj) => {
      const newSkill = {
        employeeId: obj.employeeId,
        skillName: obj.skillName,
        datesArray: obj.datesArray,
        selfRating: obj.selfRating,
        skillId: obj.skillId,
        id: obj.id,
      };

      payload.push(newSkill);
    });

    return payload;
  };

  const handleSubmit = async () => {
    if (dataValidation()) {
      const payload = CreatePayloadforApiCall();
      if (editing) {
        setLoadingApiCall(true);
        const response = await editEmployeeSkill(payload[0]);
        setLoadingApiCall(false);
        if (response.isError === false) {
          handleClose();
        }
        dipatchNotification(response.type, response.message);
      } else {
        if (payload.length === 0) {
          SetNoSkillsAdded(true);
          return;
        }
        setLoadingApiCall(true);
        const response = await addEmployeeSkill(payload);
        setLoadingApiCall(false);
        if (response.isError === false) {
          handleClose();
        }
        dipatchNotification(response.type, response.message);
      }
    }
  };

  return (
    <Container disableGutters>
      <Paper component={Box} elevation={0} p={5} pt={0}>
        <Grid container>
          <Grid
            container
            className="space-between-container"
            pt={4}
            sx={{
              backgroundColor: 'white',
              position: 'sticky',
              top: 0,
              zIndex: '2',
            }}
          >
            <Grid item>
              <IconButton sx={{ mt: '0px', ml: '-8px' }} onClick={handleClose}>
                <KeyboardBackspaceIcon />
              </IconButton>
            </Grid>
            {!editing ? (
              <Grid item>
                <IconButton onClick={addSkill}>
                  <Typography mr={1}>Add Skill</Typography>
                  <AddCircleIcon color="success" />
                </IconButton>
              </Grid>
            ) : null}
          </Grid>
          {skills.map((skill, index) => (
            <Grid container sx={{ mt: '15px', mb: '50px' }} key={index}>
              <Grid item xs={12} sx={{ mb: '15px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={5}>
                    <Autocomplete
                      value={skill}
                      freeSolo
                      disableClearable
                      id={index.toString()}
                      open={search.get(index)}
                      options={toSubjects.map((option) => {
                        return {
                          skillName: option.name,
                          skillId: option.id,
                        };
                      })}
                      getOptionLabel={(option) =>
                        eval('option.' + 'skillName')
                          ? eval('option.' + 'skillName')
                          : ''
                      }
                      onInputChange={(e, val) => checkOptions(val, index)}
                      onChange={(e, val) => handleSkillNameChange(val, index)}
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={skill.skillError}
                          variant="standard"
                          label="Skill Name"
                        />
                      )}
                      sx={{ mt: -1 }}
                      readOnly={editing}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl size="small" fullWidth>
                      <InputLabel id={`ratingLabel-${index}`}>
                        Your Rating
                      </InputLabel>
                      <Select
                        label="Your Rating"
                        labelId={`ratingLabel-${index}`}
                        error={skill.ratingError}
                        value={skill.selfRating}
                        onChange={(event) => handleRatingChange(event, index)}
                      >
                        <MenuItem value="">Select Rating</MenuItem>
                        <MenuItem value="BEGINNER">Beginner</MenuItem>
                        <MenuItem value="INTERMEDIATE">Intermediate</MenuItem>
                        <MenuItem value="ADVANCED">Advanced</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2} sx={{ mt: '5px' }}>
                    <Box display="flex" alignItems="center">
                      {skill.selfRating === 'BEGINNER' ||
                      skill.selfRating === 'INTERMEDIATE' ||
                      skill.selfRating === 'ADVANCED' ? (
                        <StarIcon
                          sx={{ fill: 'green', cursor: 'pointer' }}
                          onClick={() =>
                            handleRatingChange(
                              { target: { value: 'BEGINNER' } },
                              index,
                            )
                          }
                        />
                      ) : (
                        <StarBorderIcon
                          sx={{ cursor: 'pointer' }}
                          onClick={() =>
                            handleRatingChange(
                              { target: { value: 'BEGINNER' } },
                              index,
                            )
                          }
                        />
                      )}
                      {skill.selfRating === 'INTERMEDIATE' ||
                      skill.selfRating === 'ADVANCED' ? (
                        <StarIcon
                          sx={{ fill: 'green', cursor: 'pointer' }}
                          onClick={() =>
                            handleRatingChange(
                              { target: { value: 'INTERMEDIATE' } },
                              index,
                            )
                          }
                        />
                      ) : (
                        <StarBorderIcon
                          sx={{ cursor: 'pointer' }}
                          onClick={() =>
                            handleRatingChange(
                              { target: { value: 'INTERMEDIATE' } },
                              index,
                            )
                          }
                        />
                      )}
                      {skill.selfRating === 'ADVANCED' ? (
                        <StarIcon
                          sx={{ fill: 'green', cursor: 'pointer' }}
                          onClick={() =>
                            handleRatingChange(
                              { target: { value: 'ADVANCED' } },
                              index,
                            )
                          }
                        />
                      ) : (
                        <StarBorderIcon
                          sx={{ cursor: 'pointer' }}
                          onClick={() =>
                            handleRatingChange(
                              { target: { value: 'ADVANCED' } },
                              index,
                            )
                          }
                        />
                      )}
                    </Box>
                  </Grid>
                  {!editing ? (
                    <Grid item xs={1}>
                      <Tooltip title="Remove" placement="right">
                        <IconButton onClick={() => handleRemoveSkill(index)}>
                          <CloseIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <DatePicker
                  className="rmdp-mobile"
                  placeholder="  Select Month Range"
                  onlyMonthPicker
                  multiple
                  range
                  onChange={(value) => handleDurationChange(value, index)}
                  value={value?.get(index)}
                  style={{
                    width: '100%',
                    boxSizing: 'border-box',
                    height: '38px',
                    borderColor: skill.rangeError ? '#dc3545' : '',
                  }}
                  containerStyle={{
                    width: '100%',
                  }}
                  calendarPosition="bottom-center"
                  ref={datePickerRef}
                  mobileButtons={[
                    {
                      label: 'RESET',
                      type: 'button',
                      className: 'rmdp-button rmdp-action-button',
                      onClick: () => handleResetDuration(index),
                    },
                  ]}
                  maxDate={new Date()}
                />
              </Grid>
              {skill.datesArray.length !== 0 && (
                <Grid item xs={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Serial Number</TableCell>
                        <TableCell>Start Month</TableCell>
                        <TableCell>End Month</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {skill.datesArray.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.startMonth}</TableCell>
                          <TableCell>
                            {row.endMonth ? row.endMonth : row.startMonth}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Grid>
              )}
            </Grid>
          ))}
          <Grid
            container
            className="space-between-container"
            sx={{ mt: '25px' }}
          >
            <Grid item>
              <Button
                onClick={handleClose}
                variant="outlined"
                color={ERROR_KEY}
              >
                {CANCEL_BUTTON_TEXT}
              </Button>
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              {noSkillsAdded && (
                <Typography variant="body1" color="error">
                  {SKILL_SUBMISSION_ERROR}
                </Typography>
              )}
            </Grid>
            <Grid item>
              <LoadingButton
                onClick={handleSubmit}
                loading={loadingApiCall}
                variant="contained"
              >
                {loadingApiCall ? 'loading...' : SUBMIT_BUTTON_TEXT}
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default AddSkill;
